export default function Pricing() {
  const plans = [
    {
      name: '스타터',
      price: '월 99,000원부터',
      features: [
        '상단 노출 점프 사용 가능',
        '인재찾기 기능',
        '지원자 매칭',
        '모바일 앱 지원',
        '채팅 사용'
      ]
    }
  ];

  return (
    <section id="pricing" className="py-16 bg-gradient-to-br from-purple-50 via-white to-emerald-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-white rounded-full mb-6 shadow-sm border border-purple-100">
            <i className="ri-price-tag-3-line text-purple-600"></i>
            <span className="text-sm font-semibold text-purple-600" style={{ fontFamily: "'Pretendard', sans-serif" }}>요금제</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Pretendard', sans-serif", letterSpacing: '-0.02em' }}>
            매장에 맞는 플랜을 선택하세요
          </h2>
          <p className="text-lg text-gray-600" style={{ fontFamily: "'Pretendard', sans-serif" }}>
            합리적인 가격으로 시작하세요
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="max-w-lg mx-auto">
          {plans.map((plan, index) => (
            <div 
              key={index}
              className="relative rounded-3xl p-10 bg-white shadow-xl border-2 border-purple-100 hover:shadow-2xl hover:border-purple-200 transition-all duration-300"
            >
              {/* Popular Badge */}
              <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                <div className="px-6 py-2 bg-gradient-to-r from-purple-600 to-emerald-600 text-white text-sm font-bold rounded-full shadow-lg" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                  인기 플랜
                </div>
              </div>

              {/* Plan Header */}
              <div className="text-center mb-8 pt-4">
                <h3 className="text-3xl font-bold mb-3 text-gray-900" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                  {plan.name}
                </h3>
                <div className="flex items-baseline justify-center gap-2">
                  <span className="text-5xl font-bold bg-gradient-to-r from-purple-600 to-emerald-600 bg-clip-text text-transparent" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                    {plan.price}
                  </span>
                </div>
              </div>

              {/* Divider */}
              <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent mb-8"></div>

              {/* Features */}
              <ul className="space-y-5 mb-10">
                {plan.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-start gap-4">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 bg-gradient-to-br from-purple-100 to-emerald-100 rounded-full">
                      <i className="ri-check-line text-purple-600 text-base font-bold"></i>
                    </div>
                    <span className="text-base text-gray-700 leading-relaxed" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              {/* CTA Button */}
              <a
                href="https://pf.kakao.com/_xnxnxnxn"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full py-4 bg-gradient-to-r from-purple-600 to-emerald-600 text-white text-lg font-bold rounded-full hover:from-purple-700 hover:to-emerald-700 transition-all duration-300 text-center whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                style={{ fontFamily: "'Pretendard', sans-serif" }}
              >
                지금 시작하기
                <i className="ri-arrow-right-line ml-2"></i>
              </a>

              {/* Trust Badge */}
              <div className="mt-6 text-center">
                <div className="inline-flex items-center gap-2 text-sm text-gray-500">
                  <i className="ri-shield-check-line text-emerald-600"></i>
                  <span style={{ fontFamily: "'Pretendard', sans-serif" }}>안전한 결제 보장</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
